import { render, staticRenderFns } from "./AddCameraForClassSchoolDialog.vue?vue&type=template&id=69adb714&scoped=true"
import script from "./AddCameraForClassSchoolDialog.vue?vue&type=script&lang=js"
export * from "./AddCameraForClassSchoolDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCameraForClassSchoolDialog.vue?vue&type=style&index=0&id=69adb714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69adb714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69adb714')) {
      api.createRecord('69adb714', component.options)
    } else {
      api.reload('69adb714', component.options)
    }
    module.hot.accept("./AddCameraForClassSchoolDialog.vue?vue&type=template&id=69adb714&scoped=true", function () {
      api.rerender('69adb714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/AddCameraForClassSchoolDialog.vue"
export default component.exports